import invoicesRootSagas from './orders';
import ordersRootSagas from './invoices';

export default { invoicesRootSagas, ordersRootSagas };
